var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/display-rounded-cover-pic/display-rounded-cover-pic.html';
var html = "<div class=coverpic-img ng-class=\"{'basic-details-cover-photo': $ctrl._isBasicDetailsCoverPhoto}\"> <img ng-image-load={{$ctrl.coverPicUrl}} default-image-key=profilePic class=\"img-responsive img-circle\" alt=\"villa di maria\" ng-class=$ctrl.setCssClassNameForStatusObject($ctrl.status).iconClass> <span ng-if=\"$ctrl.status && ($ctrl.status === 'rejected'  || $ctrl.status === 'blocked')\" class=icon ng-class=$ctrl.setCssClassNameForStatusObject($ctrl.status).iconClass></span> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/display-rounded-cover-pic/display-rounded-cover-pic.html
// module id = 911
// module chunks = 0